var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrShieldCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.742,
    height: 16.491,
    viewBox: "0 0 13.742 16.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-shield-check",
    transform: "translate(-2 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5815",
    "data-name": "Path 5815",
    d: "M13.393,1.47,9.088.035a.687.687,0,0,0-.434,0L4.349,1.47A3.431,3.431,0,0,0,2,4.729V8.245c0,5.2,6.321,8.067,6.592,8.186a.687.687,0,0,0,.558,0c.271-.12,6.592-2.99,6.592-8.186V4.729A3.431,3.431,0,0,0,13.393,1.47Zm.975,6.775c0,3.748-4.342,6.207-5.5,6.795-1.156-.586-5.5-3.037-5.5-6.795V4.729a2.061,2.061,0,0,1,1.41-1.955L8.871,1.411l4.087,1.363a2.061,2.061,0,0,1,1.41,1.956Z",
    transform: "translate(0)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5816",
    "data-name": "Path 5816",
    d: "M12.744,8.208,9.866,11.094,8.324,9.486a.687.687,0,1,0-.99.952l1.584,1.649a1.286,1.286,0,0,0,.924.412h.023a1.287,1.287,0,0,0,.917-.38l2.935-2.935a.69.69,0,1,0-.974-.976Z",
    transform: "translate(-1.605 -2.505)",
    fill: "#bbc6d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrShieldCheck);
export default __webpack_public_path__ + "static/media/fi-rr-shield-check.af73c208.svg";
export { ForwardRef as ReactComponent };